import capitalize from '@utils/capitalize'
import formatStat from '@utils/formatStat'

import RegisteredIndicator, { RegisteredType } from '@elements/RegisteredIndicator'

const StatItem = ({ value, wrappable=true, textOnly=false, noComma=false }) => {
  if (!value) return '';
  if (textOnly) {
    return `${value}${noComma ? '' : ', '}`
  }
  return (
    <span style={{ whiteSpace: wrappable ? 'normal' : 'pre' }}>
      {value}{noComma ? '' : ', '}
    </span>
  )
}

const AtAGlanceDetails = ({ user, displayRegisteredIcon=true, capitalizeEach=false, wrappable=true, textOnly=false, hasUserSuffix=false, slots={ registeredIndicator: {} } }) => {
  const { registeredIndicator={} } = slots
  const extendedInfos = user?.extendedInfos || {}

  const atAGlanceStat = (statType, value) => {
    const formatted = formatStat(statType, value, { atAGlance: true, user })
    if (capitalizeEach && formatted) {
      return capitalize(formatted)
    } else {
      return formatted
    }
  }

  return (
    <>
      {displayRegisteredIcon && 
        <span>
          <RegisteredIndicator
            style={{ marginBottom: '-2px' }}
            user={user}
            {...registeredIndicator}
          />
          &nbsp;&nbsp;
        </span>
      }
      <StatItem
        value={atAGlanceStat('genderAndAge', [extendedInfos['gender'], extendedInfos['age']])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('position', extendedInfos['position'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('height', extendedInfos['height'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('weight', extendedInfos['weight'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('endowmentSize', extendedInfos['endowmentSize'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('endowmentCut', extendedInfos['endowmentCut'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('bodyType', extendedInfos['bodyType'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('sexuality', extendedInfos['sexuality'])}
        wrappable={wrappable}
        textOnly={textOnly}
      />
      <StatItem
        value={atAGlanceStat('expressionAtAGlance', extendedInfos['expression'])}
        wrappable={wrappable}
        textOnly={textOnly}
        noComma={hasUserSuffix ? false : true}
      />
      {hasUserSuffix && <RegisteredType user={user} capitalizeEach={capitalizeEach} />}
    </>
  )
}

export default AtAGlanceDetails
